module.exports = __webpack_public_path__ + "img/people.6f8a025.png";